import React from 'react';
import { Box, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import {
  DEFAULT_SIDE_TAB_LABEL,
  DEFAULT_TAB_COLOR,
  type FormDisplaySettings,
  type FormDisplayTemplate,
} from '../utils/formDisplay';

interface FormDisplayTemplatePickerProps {
  value: FormDisplayTemplate;
  triggerLabel: string;
  showOnHomePage: boolean;
  tabColor: string;
  onChange: (patch: Partial<FormDisplaySettings>) => void;
}

const FormDisplayTemplatePicker: React.FC<FormDisplayTemplatePickerProps> = ({
  value,
  triggerLabel,
  showOnHomePage,
  tabColor,
  onChange,
}) => {
  const sideTabEnabled = value === 'side-tab';
  const color = tabColor || DEFAULT_TAB_COLOR;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        Kenar şeridi
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Sağdaki ince formu switch’lerle açın, anasayfada gösterin ve rengini seçin.
      </Typography>

      <Stack spacing={1.25}>
        <FormControlLabel
          control={
            <Switch
              checked={sideTabEnabled}
              onChange={(event) => onChange({ displayTemplate: event.target.checked ? 'side-tab' : 'inline' })}
            />
          }
          label="Sağ kenar şeridini göster"
        />
        <FormControlLabel
          control={
            <Switch
              checked={showOnHomePage}
              onChange={(event) => {
                onChange({
                  showOnHomePage: event.target.checked,
                  displayTemplate: event.target.checked || sideTabEnabled ? 'side-tab' : 'inline',
                });
              }}
            />
          }
          label="Anasayfada da göster"
        />
      </Stack>

      {(sideTabEnabled || showOnHomePage) && (
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            size="small"
            label="Kenar şeridi yazısı"
            value={triggerLabel}
            onChange={(event) => onChange({ triggerLabel: event.target.value })}
            placeholder={DEFAULT_SIDE_TAB_LABEL}
            helperText="Dikey şeritte görünen kısa metin. Örn. FORMU DOLDUR"
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <TextField
              type="color"
              size="small"
              label="Şerit rengi"
              value={color}
              onChange={(event) => onChange({ tabColor: event.target.value })}
              sx={{ width: 120, '& input': { height: 36, cursor: 'pointer', p: 0.5 } }}
            />
            <TextField
              size="small"
              label="Renk kodu"
              value={color}
              onChange={(event) => onChange({ tabColor: event.target.value })}
              sx={{ width: 140 }}
            />
            <Box
              sx={{
                width: 18,
                height: 72,
                borderRadius: '10px 0 0 10px',
                background: color,
                boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
              }}
              aria-hidden
            />
          </Box>
        </Stack>
      )}
    </Box>
  );
};

export default FormDisplayTemplatePicker;
